import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1nj4tujogn: FaireBrandEntity = {
  token: "b_1nj4tujogn",
  type: "brand",
  name: "EMME nyc",
  avatarUrl:
    "https://cdn.faire.com/fastly/1bda421c50b33cc274bc76d25bac8878d409c30b104dfd9418bad220d14bc4a7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a0a20243bdb50861ed9c23ec4d620817f1a66ed75c6731cdf78849088ba85aef.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1bda421c50b33cc274bc76d25bac8878d409c30b104dfd9418bad220d14bc4a7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a0a20243bdb50861ed9c23ec4d620817f1a66ed75c6731cdf78849088ba85aef.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 11,
  isInsider: true,
  description:
    "In 2020, founders Mark and Erica were missing home after moving across the country- and when the pandemic hit, they had no idea when they would be able to return. After weeks of searching for home fragrance that truly reminded them of the nostalgic smells they grew up with, they decided to be the change they needed, and EMME nyc was born!\n\nWe stand out by featuring the authentic Asian scents we grew up with that are frequently overlooked or misrepresented. All of our products are non-toxic, pet-safe, and designed with sleek, modern aesthetics to complement any decor. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:46.686Z",
    importedBy: "entity-db-cli",
  },
};
